export default __webpack_public_path__ + "static/media/fc-icon-32-light.3dc7217c.svg";